import type { LiveChatVisitor } from '@nucleus-commerce/api-client/admin';

/** The visitor's name or email when they gave one; `null` for "Visitor 4F2A". */
export function visitorName(
  visitor: Pick<LiveChatVisitor, 'displayName' | 'email'>,
): string | null {
  const name = [visitor.displayName, visitor.email].find(
    (value): value is string => typeof value === 'string' && value.trim() !== '',
  );
  return name ?? null;
}

/** "Boston, US" from the API's GeoIP lookup, else the browser language, else null. */
export function visitorLocation(
  visitor: Pick<LiveChatVisitor, 'city' | 'region' | 'country' | 'locale'>,
): string | null {
  const place = [visitor.city, visitor.country].filter(Boolean).join(', ');
  return place !== '' ? place : visitor.locale;
}

/** Whole minutes on the site, never negative (clocks drift). */
export function minutesOnSite(startedAt: string, now: number): number {
  return Math.max(0, Math.floor((now - Date.parse(startedAt)) / 60_000));
}

export const SAFE_URL = /^https?:\/\//i;
